import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PreferencesOptionComponent } from './preferences-option/preferences-option.component';
import { PreferenceMainComponent } from './preference-main/preference-main.component';

@NgModule({
    declarations: [PreferenceMainComponent, PreferencesOptionComponent],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule
    ],
    exports: [PreferenceMainComponent]
})
export class PreferencesModule { }

// translation loader moved to SharedModule